module.exports = __webpack_public_path__ + "assets/img/mitre.1fa37ff9.png";